import { atomWithStorage } from 'jotai/utils'
import type {
  AnalyzeProgress,
  CalculationProgress,
  ExchangeApiProgress,
} from '../types'

export const progressesAtom = atomWithStorage<AnalyzeProgress[]>(
  'progresses',
  [],
)
progressesAtom.onMount = (set) => {
  set([])
}

export const exchangeApiProgressesAtom = atomWithStorage<
  Record<string, ExchangeApiProgress | undefined>
>('exchange-api-progresses', {})
exchangeApiProgressesAtom.onMount = (set) => {
  set({})
}

export const calculationProgressAtom = atomWithStorage<
  CalculationProgress | undefined
>('calculation-progress', undefined)
calculationProgressAtom.onMount = (set) => {
  set(undefined)
}
